export const Logo = ({ size }) => {
  return (
    <>
      <img className={size} src="/src/assets/img/1.png" alt="flappy-logo" />
    </>
  );
};
